
import React, { useState } from 'react';

const GallerySection: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    {
      id: 1,
      title: 'Cửa hàng Giặt Ủi Minh Khôi',
      image: 'https://public.readdy.ai/ai/img_res/64594c62a95360840f673848ce843644.jpg',
      category: 'Cửa hàng'
    },
    {
      id: 2,
      title: 'Xưởng giặt chuyên nghiệp',
      image: 'https://readdy.ai/api/search-image?query=Professional%20laundry%20workshop%20interior%20with%20industrial%20washing%20machines%2C%20clean%20organized%20workspace%2C%20modern%20equipment%2C%20bright%20lighting%2C%20professional%20laundry%20facility%2C%20commercial%20laundry%20equipment%2C%20hygienic%20environment&width=400&height=300&seq=gallery-workshop-1&orientation=landscape',
      category: 'Xưởng giặt'
    },
    {
      id: 3,
      title: 'Máy giặt công nghiệp',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20washing%20machines%20in%20professional%20laundry%2C%20large%20capacity%20commercial%20washers%2C%20modern%20laundry%20equipment%2C%20stainless%20steel%20machines%2C%20professional%20laundry%20technology%2C%20clean%20industrial%20environment&width=400&height=300&seq=gallery-machines-1&orientation=landscape',
      category: 'Thiết bị'
    },
    {
      id: 4,
      title: 'Đồ giặt sạch được gấp gọn',
      image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20clean%20white%20linens%2C%20hotel%20quality%20bed%20sheets%2C%20towels%2C%20perfectly%20organized%20laundry%2C%20professional%20folding%2C%20pristine%20white%20fabrics%2C%20clean%20laundry%20results%2C%20hotel%20standard%20cleanliness&width=400&height=300&seq=gallery-clean-1&orientation=landscape',
      category: 'Sản phẩm'
    },
    {
      id: 5,
      title: 'Chăn mền sau khi giặt',
      image: 'https://readdy.ai/api/search-image?query=Clean%20fresh%20blankets%20and%20comforters%20after%20washing%2C%20fluffy%20white%20bedding%2C%20professional%20laundry%20results%2C%20soft%20clean%20blankets%2C%20hotel%20quality%20bedding%2C%20pristine%20white%20comforters%2C%20fresh%20clean%20linens&width=400&height=300&seq=gallery-blankets-1&orientation=landscape',
      category: 'Sản phẩm'
    },
    {
      id: 6,
      title: 'Khu vực ủi đồ',
      image: 'https://readdy.ai/api/search-image?query=Professional%20ironing%20station%20in%20laundry%20facility%2C%20commercial%20ironing%20equipment%2C%20organized%20pressing%20area%2C%20professional%20garment%20care%2C%20industrial%20ironing%20setup%2C%20clean%20workspace%20for%20pressing%20clothes&width=400&height=300&seq=gallery-ironing-1&orientation=landscape',
      category: 'Thiết bị'
    },
    {
      id: 7,
      title: 'Đồ khách sạn sau giặt',
      image: 'https://readdy.ai/api/search-image?query=Hotel%20linens%20after%20professional%20washing%2C%20pristine%20white%20hotel%20bedding%2C%20towels%2C%20bathrobes%2C%20perfectly%20clean%20hotel%20textiles%2C%20luxury%20hotel%20quality%20laundry%2C%20professional%20hotel%20linen%20service&width=400&height=300&seq=gallery-hotel-1&orientation=landscape',
      category: 'Sản phẩm'
    },
    {
      id: 8,
      title: 'Khu vực sấy khô',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20drying%20area%20in%20professional%20laundry%2C%20industrial%20dryers%2C%20clean%20organized%20drying%20facility%2C%20modern%20laundry%20equipment%2C%20professional%20drying%20systems%2C%20efficient%20laundry%20operations&width=400&height=300&seq=gallery-drying-1&orientation=landscape',
      category: 'Thiết bị'
    }
  ];

  const categories = ['Tất cả', 'Cửa hàng', 'Xưởng giặt', 'Thiết bị', 'Sản phẩm'];
  const [activeCategory, setActiveCategory] = useState('Tất cả');

  const filteredImages = activeCategory === 'Tất cả' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Hình ảnh xưởng giặt
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Khám phá cơ sở vật chất hiện đại và quy trình giặt ủi chuyên nghiệp của chúng tôi
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeCategory === category
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(image.image)}
              >
                <img
                  src={image.image}
                  alt={image.title}
                  className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 flex items-center justify-center">
                  <div className="text-white text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-eye-line text-3xl mb-2"></i>
                    <p className="font-semibold">{image.title}</p>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <p className="text-white font-medium text-sm">{image.title}</p>
                  <p className="text-gray-300 text-xs">{image.category}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Image Modal */}
          {selectedImage && (
            <div 
              className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
              onClick={() => setSelectedImage(null)}
            >
              <div className="relative max-w-4xl max-h-full">
                <img
                  src={selectedImage}
                  alt="Gallery Image"
                  className="max-w-full max-h-full object-contain"
                />
                <button
                  onClick={() => setSelectedImage(null)}
                  className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>
            </div>
          )}

          {/* Call to Action */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-blue-600 to-teal-600 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">Trải nghiệm dịch vụ chất lượng cao</h3>
              <p className="text-lg mb-6 opacity-90">
                Hãy đến thăm cửa hàng để tận mắt chứng kiến quy trình giặt ủi chuyên nghiệp của chúng tôi
              </p>
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Liên hệ ngay
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
